export default __webpack_public_path__ + "static/media/contractingvideo.4837b279.mp4";